module.exports = __webpack_public_path__ + "static/media/csengo_inaktiv.57ca36e6.svg";